export default __webpack_public_path__ + "static/media/Thaumaturge's Girdle of Imperial Assent.3d996c53.jpg";